type IconName =
  | "dashboard"
  | "tasks"
  | "costs"
  | "projects"
  | "workflow"
  | "integrations"
  | "permissions"
  | "building"
  | "spark"
  | "microsoft"
  | "google"
  | "check"
  | "x"
  | "user"
  | "bot"
  | "log-out";

type Props = { name?: string; className?: string; strokeWidth?: number };

const common = "shrink-0";

export default function Icon({ name = "building", className = "h-4 w-4", strokeWidth = 1.8 }: Props) {
  const cls = `${common} ${className}`;
  const stroke = { stroke: "currentColor", strokeWidth, strokeLinecap: "round" as const, strokeLinejoin: "round" as const };
  switch (name as IconName) {
    case "dashboard":
      return <svg viewBox="0 0 24 24" fill="none" className={cls}><rect x="3" y="3" width="7" height="8" rx="1.5" {...stroke}/><rect x="14" y="3" width="7" height="5" rx="1.5" {...stroke}/><rect x="14" y="12" width="7" height="9" rx="1.5" {...stroke}/><rect x="3" y="15" width="7" height="6" rx="1.5" {...stroke}/></svg>;
    case "tasks":
      return <svg viewBox="0 0 24 24" fill="none" className={cls}><path d="M9 6h11M9 12h11M9 18h11" {...stroke}/><path d="m3.5 6 1.2 1.2L7 4.8M3.5 12l1.2 1.2L7 10.8M3.5 18l1.2 1.2L7 16.8" {...stroke}/></svg>;
    case "costs":
      return <svg viewBox="0 0 24 24" fill="none" className={cls}><path d="M12 2v20M17 6.5c-.9-1-2.4-1.6-4.2-1.6-2.4 0-4.1 1.1-4.1 2.9 0 4.4 8.8 1.8 8.8 6.7 0 1.9-1.8 3.1-4.6 3.1-2.2 0-4-.8-5-2.1" {...stroke}/></svg>;
    case "projects":
    case "building":
      return <svg viewBox="0 0 24 24" fill="none" className={cls}><path d="M4 21V7.5L12 3l8 4.5V21" {...stroke}/><path d="M8 21v-8h8v8M8 9h.01M12 9h.01M16 9h.01" {...stroke}/></svg>;
    case "workflow":
      return <svg viewBox="0 0 24 24" fill="none" className={cls}><circle cx="6" cy="6" r="3" {...stroke}/><circle cx="18" cy="18" r="3" {...stroke}/><circle cx="18" cy="6" r="3" {...stroke}/><path d="M9 6h6M8.2 8.2 15.8 15.8" {...stroke}/></svg>;
    case "integrations":
      return <svg viewBox="0 0 24 24" fill="none" className={cls}><path d="M8 12h8M9 7H7a5 5 0 0 0 0 10h2M15 7h2a5 5 0 0 1 0 10h-2" {...stroke}/></svg>;
    case "permissions":
      return <svg viewBox="0 0 24 24" fill="none" className={cls}><path d="M12 3 5 6v5c0 4.5 3 8.3 7 10 4-1.7 7-5.5 7-10V6l-7-3Z" {...stroke}/><path d="m9.5 12 1.7 1.7 3.6-4" {...stroke}/></svg>;
    case "spark":
      return <svg viewBox="0 0 24 24" fill="none" className={cls}><path d="M12 3l1.6 5.4L19 10l-5.4 1.6L12 17l-1.6-5.4L5 10l5.4-1.6L12 3ZM19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8L19 15Z" {...stroke}/></svg>;
    case "microsoft":
      return <svg viewBox="0 0 24 24" fill="currentColor" className={cls}><path d="M3 3h8v8H3V3Zm10 0h8v8h-8V3ZM3 13h8v8H3v-8Zm10 0h8v8h-8v-8Z"/></svg>;
    case "google":
      return <svg viewBox="0 0 24 24" fill="none" className={cls}><path d="M20.5 12.2c0-.7-.1-1.3-.2-1.9H12v3.5h4.8a4.1 4.1 0 0 1-1.8 2.7v2.2h2.9c1.7-1.5 2.6-3.8 2.6-6.5Z" fill="currentColor" opacity=".8"/><path d="M12 21c2.4 0 4.4-.8 5.9-2.2L15 16.5c-.8.5-1.8.9-3 .9-2.3 0-4.3-1.6-5-3.7H4v2.3A9 9 0 0 0 12 21Z" fill="currentColor" opacity=".65"/><path d="M7 13.7a5.4 5.4 0 0 1 0-3.4V8H4a9 9 0 0 0 0 8l3-2.3Z" fill="currentColor" opacity=".5"/><path d="M12 6.6c1.3 0 2.5.5 3.4 1.3L18 5.4A8.8 8.8 0 0 0 12 3a9 9 0 0 0-8 5l3 2.3c.7-2.1 2.7-3.7 5-3.7Z" fill="currentColor"/></svg>;
    case "check":
      return <svg viewBox="0 0 24 24" fill="none" className={cls}><path d="m5 12 4 4L19 6" {...stroke}/></svg>;
    case "x":
      return <svg viewBox="0 0 24 24" fill="none" className={cls}><path d="M6 6l12 12M18 6 6 18" {...stroke}/></svg>;
    case "user":
      return <svg viewBox="0 0 24 24" fill="none" className={cls}><circle cx="12" cy="8" r="4" {...stroke}/><path d="M4 21a8 8 0 0 1 16 0" {...stroke}/></svg>;
    case "bot":
      return <svg viewBox="0 0 24 24" fill="none" className={cls}><rect x="5" y="7" width="14" height="11" rx="3" {...stroke}/><path d="M12 7V4M9 12h.01M15 12h.01M9 16h6" {...stroke}/></svg>;
    case "log-out":
      return <svg viewBox="0 0 24 24" fill="none" className={cls}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" {...stroke}/></svg>;
    default:
      return <svg viewBox="0 0 24 24" fill="none" className={cls}><circle cx="12" cy="12" r="8" {...stroke}/></svg>;
  }
}
